import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-globalaction-field",
  templateUrl: "./globalaction-field.component.html",
  styleUrls: ["./globalaction-field.component.scss"],
})
export class GlobalactionFieldComponent implements OnInit {
  @Input() data: any;
  @Input() inputdata: any;
  inputField: any;
  droppedFields: any[] = [];

  constructor() {}

  ngOnInit() {
    console.log("inputField", this.inputField);

    if (this.inputdata) {
      console.log("inputdata", this.inputdata);
    }
    this.droppedFields = this.inputdata.map((item) => ({
      ...item,
      dropped: false,
    }));
  }

  fields: any[] = [];

  addItem() {
    this.fields.push({});
  }

  removeItem() {
    this.fields.pop();
  }

  onDragStart(event: DragEvent, item: any) {
    // console.log(' field data:', this.inputdata);
    console.log(" field data:", item);

    if (item.dropped) {
      event.preventDefault();
      return;
    }

    event.dataTransfer.setData("application/json", JSON.stringify(item));
  }
}

export interface iField {
  labelname: string;
}
